import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class SealApplicationApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'seal-application'
  }

}